import { render, staticRenderFns } from "./cartao-cabecalho.vue?vue&type=template&id=5cf41768&scoped=true&"
import script from "./cartao-cabecalho.vue?vue&type=script&lang=js&"
export * from "./cartao-cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./cartao-cabecalho.vue?vue&type=style&index=0&id=5cf41768&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf41768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf41768')) {
      api.createRecord('5cf41768', component.options)
    } else {
      api.reload('5cf41768', component.options)
    }
    module.hot.accept("./cartao-cabecalho.vue?vue&type=template&id=5cf41768&scoped=true&", function () {
      api.rerender('5cf41768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/ui-registry/cartao-cabecalho.vue"
export default component.exports